import React from "react";
import PropTypes from "prop-types";

const InformModal = ({
  showModal = false,
  modalSize = "md",
  message = "",
  children = null,
}) => {
  return showModal ? (
    <div
      className={`modal m-0 p-0 ${showModal ? "d-block show" : "d-none fade"}`}
      tabIndex="-1"
    >
      <div className="overlay position-fixed vw-100 vh-100 bg-dark bg-opacity-10" />
      <div className={`modal-dialog modal-${modalSize}`}>
        <div className="modal-content p-2">
          <div className="modal-body">{message || children}</div>
        </div>
      </div>
    </div>
  ) : null;
};

export default InformModal;

InformModal.propTypes = {
  modalSize: PropTypes.string,
  showModal: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
};
